const HomeAdminPage = () =>{
    return (
        <div>
            Admin Page
        </div>
    )
}
export default HomeAdminPage